import { createElement } from 'react';
import { storageServiceOf } from '../../../../types/azureStorage';
import {
  registerStorageToolbarExtension,
  TOOLBAR_OVERFLOW_PRIORITY,
  type StorageToolbarContext,
  type StorageToolbarExtension,
} from '../toolbar/toolbarExtensions';
import { S3PropertiesMenuItem, S3PropertiesToolbarButton, S3SasToolbarButton } from './toolbar/S3ToolbarButtons';

export { StorageDialogHost } from './dialogs/StorageDialogHost';

type Register = (extension: StorageToolbarExtension) => void;
const registered = new WeakSet<Register>();
const blobRoot = (context: StorageToolbarContext): boolean => storageServiceOf(context.root) === 'blob';

/**
 * S3's toolbar entries on S2's registry (order band 200–299). They render S3 components and open S3 surfaces through
 * S3's own action API (the properties-panel bridge keyed by `capabilities.tabId`, the S3 dialog store); S2's
 * `openDialog(ReactNode)` context is left untouched for S2's own dialogs (review C D6).
 */
const extensions: StorageToolbarExtension[] = [
  {
    id: 's3-properties', placement: 'primary', order: 200, isVisible: blobRoot, render: (context) => createElement(S3PropertiesToolbarButton, { context }),
    overflow: { priority: TOOLBAR_OVERFLOW_PRIORITY.properties, renderMenuItem: (context) => createElement(S3PropertiesMenuItem, { context }) },
  },
  { id: 's3-sas', placement: 'more', order: 210, isVisible: blobRoot, render: (context) => createElement(S3SasToolbarButton, { context }) },
];

export function registerStorageS3ToolbarExtensions(register: Register = registerStorageToolbarExtension): void {
  if (registered.has(register)) return;
  registered.add(register);
  for (const extension of extensions) register(extension);
}

registerStorageS3ToolbarExtensions();
